import React, { Fragment, useState } from "react";
import "../../templateform/templateform.css";
import Accordion from "react-bootstrap/Accordion";
import { isEmpty } from "utils/utils";
import { isVideo } from "utils/utils";
import { Form, InputGroup, Row, Col } from 'react-bootstrap';

function Personalinformation(props) {
  const { setSociallinks, categoriesKeys, setFormDetail, formDetail,
    sociallinks, documentFile, setDocumentFile, profileImage, setProfileImage, logoImage, setLogoImage,
    bannerImage, setBannerImage,
    workingHours, setWorkingHours,
    aboutMedia, setAboutMedia, languageData
  } = props;

  // Define socialVisibility and handleToggleVisibility within the component
  const [socialVisibility, setSocialVisibility] = useState({
    linkedin: true,
    facebook: true,
    twitter: true,
    instagram: true,
    pinterest: true,
    github: true,
    youtube: false,
  });

  const handleToggleVisibility = (platform) => {
    setSocialVisibility((prevState) => ({
      ...prevState,
      [platform]: !prevState[platform],
    }));
  };
  const handleInput = (e) => {
    const { name, value } = e.target
    let resVal = {
      ...formDetail,
      [name]: { ...formDetail[name], value: value }
    }
    setFormDetail(resVal)
  }

  const handleSwitchButton = (name, value) => {
    let status = true
    if (value === true || value === 'true') {
      status = false
    }
    let resVal = {
      ...formDetail,
      [name]: { ...formDetail[name], status: status }
    }
    setFormDetail(resVal)
  }

  const handleSocialsInputValue = (index, name, value) => {
    let arr = [...sociallinks.accounts]
    // let arrObj = arr[index]
    arr[index][name] = value
    setSociallinks({ ...sociallinks, accounts: arr })
  }
  const handleTimeChange = (index, field, value) => {
    const updatedHours = [...workingHours.hours];
    updatedHours[index][field] = value;
    setWorkingHours({ ...workingHours, hours: updatedHours });
  };
  const socialImg = {
    github: <i className="fab fa-github"></i>,
    facebook: <i className="fab fa-facebook"></i>,
    instagram: <i className="fab fa-instagram"></i>,
    linkedin: <i className="fab fa-linkedin"></i>,
    pinterest: <i className="fab fa-pinterest"></i>,
    twitter: <i className="fab fa-twitter"></i>,
    azure: <i className="fab fa-youtube"></i>,
    bitbucket: <i class="fab fa-bitbucket"></i>,
  }
  // const handleFileUpload = (e) => {
  //     let file = e.target.files[0];
  //     let fileType = file.type; // image/jpeg
  //     let fileSize = file.size; // 3MB

  //     if (fileSize > 5 * 1000000) {
  //         // fileSize > 5MB then show popup message
  //         alert(
  //             `File size is too large, please upload image of size less than 5MB.\nSelected File Size: ${fileSize / 1000000
  //             }MB only`
  //         );
  //         return;
  //     }
  // };
  return (
    <Fragment>
      <Accordion.Header>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img src="/assets/images/icon/user.png" alt="Personal Information" width={'12%'} /> <span style={{ marginLeft: '15px' }}>{languageData?.personalInformation}</span>
        </div>
      </Accordion.Header>
      <Accordion.Body>
        {!isEmpty(categoriesKeys) &&
          (<div className="row">
            {categoriesKeys.full_name === true &&
              <div className="col-lg-6 col-md-6">
                <div className="input-field-box">
                  <label className="forn_title">{languageData?.fullName}:</label>
                  <input
                    placeholder={languageData?.enterYouName}
                    className="form-control"
                    name="name"
                    // onChange={(e) => setFormDetail({ ...formDetail, name:  e.target.value })}
                    onChange={(e) => handleInput(e)}
                    value={formDetail?.name?.value}
                  />
                </div>
              </div>
            }
            {categoriesKeys.company_name === true &&
              <div className="col-lg-6 col-md-6">
                <div className="input-field-box">
                  <label className="forn_title">{languageData?.companyName}:</label>
                  <input
                    placeholder={languageData?.enterYouCompanyName}
                    className="form-control"
                    name="company_name"
                    // onChange={(e) => setFormDetail({ ...formDetail, name:  e.target.value })}
                    onChange={(e) => handleInput(e)}
                    value={formDetail?.company_name?.value}
                  />
                </div>
              </div>
            }
            {categoriesKeys.company_tagline === true &&
              <div className="col-lg-6 col-md-6">
                <div className="input-field-box">
                  <label className="forn_title">{languageData?.companyTagline}:</label>
                  <input
                    placeholder={languageData?.enterYouCompanyTagline}
                    className="form-control"
                    name="company_tagline"
                    // onChange={(e) => setFormDetail({ ...formDetail, name:  e.target.value })}
                    onChange={(e) => handleInput(e)}
                    value={formDetail?.company_tagline?.value}
                  />
                </div>
              </div>
            }
            {categoriesKeys.self_describes === true &&
              <div className="col-lg-6 col-md-6">
                <div className="input-field-box">
                  <label className="forn_title">{languageData?.profession}:</label>
                  <input
                    placeholder={languageData?.enterSelfDescribes}
                    className="form-control"
                    name="profession"
                    onChange={(e) => handleInput(e)}
                    value={formDetail?.profession?.value}
                  />
                </div>
              </div>
            }
            {categoriesKeys.mobile === true &&
              <div className="col-lg-6 col-md-6">
                <div className="input-field-box">
                  <label className="forn_title">{languageData?.phone}:</label>
                  <input
                    placeholder={languageData?.enterNumber}
                    className="form-control"
                    type="number"
                    name="phone"
                    onChange={(e) => handleInput(e)}
                    value={formDetail?.phone?.value}
                  />
                </div>
              </div>
            }
            {categoriesKeys.email === true &&
              <div className="col-lg-6 col-md-6">
                <div className="input-field-box">
                  <label className="forn_title">{languageData?.email}:</label>
                  <input
                    placeholder={languageData?.enterEmail}
                    className="form-control"
                    type="email"
                    name="email"
                    onChange={(e) => handleInput(e)}
                    value={formDetail?.email?.value}
                  />
                </div>
              </div>
            }

            {categoriesKeys.address === true &&
              <>
                <div className="col-lg-6 col-md-6">
                  <div className="input-field-box">
                    <label className="forn_title">{languageData?.address}:</label>
                    <div className="input-field-box mb-2" style={{ display: 'flex' }}>
                      <input
                        placeholder={languageData?.address1}
                        className="form-control"
                        type="text"
                        name="address"
                        onChange={(e) => handleInput(e)}
                        value={formDetail?.address?.value}
                      />
                    </div>
                    {/* <div className="input-field-box" style={{ display: 'flex' }}>
                      <input
                        placeholder={languageData?.address2}
                        className="form-control"
                        type="text"
                        name="address"
                        onChange={(e) => handleInput(e)}
                        value={formDetail?.address?.value}
                      />
                    </div> */}
                  </div>
                </div>
                <div className="col-lg-6 col-md-6"></div>
              </>
            }

            {categoriesKeys.social === true &&
              <div className="col-lg-12">
                <div className="input-field-box">
                  <label className="forn_title">{languageData?.social}:</label>
                  <div className="row">
                    {sociallinks && sociallinks.accounts && sociallinks.accounts.length > 0 && sociallinks.accounts.map((item, index) => (
                      <div className="col-lg-6 col-md-6" key={index}>
                        <InputGroup className="my-2">
                          <InputGroup.Text>
                            {socialImg[item.social]}
                          </InputGroup.Text>
                          <Form.Control placeholder="https://www.linkedin.com/in/" value={item.link}
                            onChange={(e) => handleSocialsInputValue(index, 'link', e.target.value)} />
                          <label className="custom-toggle-ios m-1">
                            <input
                              type="checkbox"
                              checked={item.status}
                              onChange={() => handleSocialsInputValue(index, 'status', !item.status)}
                            />
                            <span className="slider-ios">{item.status ? 'Show' : 'Hide'}</span>
                          </label>

                        </InputGroup>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            }

            {categoriesKeys.working_hours === true &&
              <div className="col-lg-12">
                <div className="row__" style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <div className="col-lg-10___">
                    <div className="input-field-box">
                      <label className="forn_title mb-4">{languageData?.workingHours}:</label>
                    </div>
                  </div>
                  <div className="col-lg-2___">
                    {/* <label className="thm_switch__btn drop_swich_btn" style={{ float: 'right' }}>
                      <input className="thm_switch_input" type="checkbox" onChange={(e) => setWorkingHours({ ...workingHours, status: !workingHours.status })} value={formDetail.address.status} checked={workingHours.status} />
                      <span className="thm_switch_slider round"></span>
                    </label> */}
                    <Form.Check
                      defaultChecked={workingHours?.status}
                      style={{ marginRight: 20, display: 'inline-block', zIndex: 0 }}
                      type="switch"
                      className="custom-switch"
                      onChange={(e) => setWorkingHours({ ...workingHours, status: !workingHours.status })}
                      onClick={(e) => e.stopPropagation()} // Prevent event bubbling
                    />
                  </div>
                </div>
                <div className="input-field-box">
                  <div className="row">
                    {workingHours && workingHours.hours && workingHours.hours.length > 0 && workingHours.hours.map((item, index) => (
                      <div className="col-lg-6 col-md-6" key={index}>

                        <div className="col-lg-12" style={{ display: 'flex' }}>
                          <div className="col-lg-3 text-center" style={{ marginRight: 10 }}>
                            <small>{item.day} :</small>
                          </div>
                          <div className="col-lg-8 input-field-box" style={{ display: 'flex' }}>
                            <div style={{ marginRight: 10 }}>
                              <input
                                type="time"
                                placeholder={languageData?.openTime}
                                className="form-control"
                                value={item.open}
                                onChange={(e) => handleTimeChange(index, 'open', e.target.value)}
                              />
                            </div>
                            <div>
                              <input
                                type="time"
                                placeholder={languageData?.closeTime}
                                className="form-control"
                                value={item.close}
                                onChange={(e) => handleTimeChange(index, 'close', e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            }

            {categoriesKeys.profile === true &&
              <div className="col-lg-6 col-md-6">
                <div className="input-field-box">
                  <label className="forn_title">{languageData?.uploadProfileImage}:</label>
                  <div className="d-block d-md-flex w-full">
                    <div style={{ padding: '1rem' }}>
                      <input
                        placeholder={`+ ${languageData?.uploadYourBannerImage}`}
                        type="file"
                        className="form-control"
                        style={{ display: 'none' }}
                        id="profileFile"
                        accept="image/png, image/jpg, image/jpeg"
                        onChange={(e) => setProfileImage(e.target.files)}
                      />
                      <a className="select_profile_btn" htmlFor="exampleInputFile" onClick={() => document.getElementById('profileFile').click()} >{languageData?.upload}</a>
                    </div>
                    <div style={{ maxWidth: '100px' }}>
                      <img src={!isEmpty(profileImage) ? URL.createObjectURL(profileImage[0]) : formDetail.profile_image} alt="profile" width={'100%'} />
                    </div>
                  </div>
                  <span style={{ fontSize: 13, color: '#444' }}>
                    {languageData?.sizeShouldBeLessThan}
                  </span>
                </div>
              </div>
            }
            {categoriesKeys.logo === true &&
              <div className="col-lg-6 col-md-6">
                <div className="input-field-box">
                  <label className="forn_title">{languageData?.uploadLogo}:</label>
                  <div className="d-block d-md-flex w-full">
                    <div style={{ padding: '1rem' }}>
                      <input
                        placeholder={`+ ${languageData?.uploadYourLogo}`}
                        type="file"
                        className="form-control"
                        style={{ display: 'none' }}
                        id="logoFile"
                        accept="image/png, image/jpg, image/j peg"
                        onChange={(e) => setLogoImage(e.target.files)}
                      />
                      <a className="select_profile_btn" htmlFor="exampleInputFile" onClick={() => document.getElementById('logoFile').click()} >{languageData?.selectImage}</a>
                    </div>
                    <div style={{ maxWidth: '100px' }}>
                      {(logoImage != null || (formDetail?.logo != undefined && formDetail?.logo != null)) &&
                        <img src={!isEmpty(logoImage) ? URL.createObjectURL(logoImage[0]) : formDetail?.logo} alt="logo" width={'100%'} />
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
            {categoriesKeys.banner_image === true &&
              <div className="col-lg-6 col-md-6">
                <div className="input-field-box">
                  <label className="forn_title">{languageData?.uploadBannerImage}:<small>({languageData?.fileResolutionIsGreaterThen})</small></label>
                  <div className="d-block d-md-flex w-full">
                    <div style={{ padding: '1rem' }}>
                      <input
                        placeholder={`+ ${languageData?.uploadYourBannerImage}`}
                        type="file"
                        className="form-control"
                        style={{ display: 'none' }}
                        id="banner_image"
                        accept="image/png, image/jpg, image/jpeg"
                        onChange={(e) => setBannerImage(e.target.files)}
                      />
                      <a className="select_profile_btn" htmlFor="exampleInputFile" onClick={() => document.getElementById('banner_image').click()} >{languageData?.selectImage}</a>
                    </div>
                    <div style={{ maxWidth: '100px' }}>
                      <img src={!isEmpty(bannerImage) ? URL.createObjectURL(bannerImage[0]) : formDetail?.banner_image} alt="banner_image" width={'100%'} />
                    </div>
                  </div>
                </div>
              </div>
            }
            {categoriesKeys.document === true &&
              <div className="col-lg-6 col-md-6">
                <div className="input-field-box">
                  <label className="forn_title">{categoriesKeys.company_tagline ? "Company brochure" : "Resume"}:</label>
                  <div className="d-block d-md-flex w-full">
                    <div style={{ padding: '1rem' }}>
                      <input
                        placeholder="+ Upload your banner image"
                        type="file"
                        className="form-control"
                        style={{ display: 'none' }}
                        id="documentFile"
                        onChange={(e) => setDocumentFile(e.target.files)}
                        accept="application/pdf,application/doc"
                      />
                      <a className="select_profile_btn" htmlFor="exampleInputFile" onClick={() => document.getElementById('documentFile').click()} >Upload</a>
                      <p style={{ margin: '10px 50px 0 0' }}>{documentFile !== null && documentFile[0].name}</p>
                    </div>
                    <div style={{ maxWidth: '100px' }}>
                      {!isEmpty(documentFile) && <>
                        <img src='/assets/images/pdf_icon.png' alt="document" width={'100%'} />
                      </>
                      }
                    </div>
                  </div>
                  <span style={{ fontSize: 13, color: '#444' }}>
                    Size should be less than 5mb
                  </span>
                </div>
              </div>
            }
            {categoriesKeys.about_media === true &&
              <div className="col-lg-6 col-md-6">
                <div className="input-field-box">
                  <label className="forn_title">{languageData?.aboutMedia}{/* <small> ({languageData?.imageVideo})</small> */}:</label>
                  <div style={{ display: 'flex', width: '100%' }}>
                    <div style={{ width: '60%', padding: '1rem' }}>
                      <input
                        placeholder="+ Upload your about media"
                        type="file"
                        className="form-control"
                        style={{ display: 'none' }}
                        id="mediaFile"
                        onChange={(e) => setAboutMedia(e.target.files)}
                        // accept="image/png, image/jpg, image/jpeg, video/mp4"
                        accept="image/png, image/jpg, image/jpeg"
                      />
                      <a className="select_profile_btn" htmlFor="exampleInputFile" onClick={() => document.getElementById('mediaFile').click()} >{languageData?.selectMedia}</a>
                    </div>
                    <div style={{ maxWidth: '100px' }}>
                      {!isEmpty(aboutMedia) ?
                        isVideo(aboutMedia[0].name) ? ( // Check if it's a video URL
                          <video width="250" height="110" controls>
                            <source src={URL.createObjectURL(aboutMedia[0])} type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        ) : (
                          <img src={URL.createObjectURL(aboutMedia[0])} alt={`aboutMedia`} />
                        ) :
                        !isEmpty(formDetail?.about_media) && isVideo(formDetail?.about_media) ? ( // Check if it's a video URL
                          <video width="250" height="110" controls>
                            <source src={formDetail?.about_media} type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        ) : formDetail?.about_media != undefined && !isEmpty(formDetail?.about_media) &&
                        (<img src={formDetail?.about_media} alt={`aboutMedia`} />)
                      }
                    </div>

                  </div>
                </div>
              </div>
            }
          </div>
          )}
      </Accordion.Body>
    </Fragment>
  );
}
export default Personalinformation;
